/**
 * The diagnostics module's paths.
 *
 * `/diagnostics` is the FLEET view — "which of my vehicles are not reporting CAN, and
 * what is their program number" — because that is the question somebody arrives with,
 * and the per-vehicle page is where they end up after finding the row. The reverse
 * nesting (`/vehicles/:id/diagnostics`) would make the installer's screen unreachable
 * without first choosing a vehicle, which is the one thing they cannot do yet.
 *
 * Route registration lives in `routes/app-routes.tsx` — see NOTES-PHASE4-WEB.md §1.
 */
export const DIAGNOSTICS_PATH = '/diagnostics'
export const VEHICLE_DIAGNOSTICS_PATH = '/diagnostics/vehicles/:vehicleId'

export function vehicleDiagnosticsPath(vehicleId: string): string {
  return `${DIAGNOSTICS_PATH}/vehicles/${vehicleId}`
}
